import {catchError, map} from 'rxjs/operators';
import {pipe} from 'rxjs/internal-compatibility';
import {of} from 'rxjs/internal/observable/of';

export const requestErrorMap = (field?: string) => pipe(
  map(res => ({ hasError: false, res })),
  catchError(err => {
    console.error(err);
    return of({ hasError: true, err, field });
  }),
);

export const requestFieldMap = (field: string) => pipe(
  map(res => ({ field, res })),
);
